//import React from 'react';

import { Polling } from '_core/polling';
import * as cache from '_core/utils/cache';


export const getClientVisitorStatusTypes = () => getList('client/visitor/status/types', null);

export const useClientVisitorStatusTypes = (onSuccess) => useList('client/visitor/status/types', null, onSuccess);

export const useMoneyCurrencyList = (onSuccess) => useData('money/currency/list', null, onSuccess);

export const getMoneyAccountList = () => getList('money/account/list', null);

export const getMoneyAccountBalance = () => getList('money/account/balance', null, 5 * 60000);

export const clearMoneyAccountBalance = () => cache.clear(null, 'money/account/balance');

export const getOfficeSettingsValues = () => getData('office/settings/values', null);

export const getOfficeSettingsValue = async (name, defaultValue) => {
  try {
    const result = (await getOfficeSettingsValues())[name];
    
    if (typeof result === 'undefined' || result === null)
      return typeof defaultValue === 'undefined' ? result : defaultValue;
    
    return result;
  } catch (e) {
    if (typeof defaultValue === 'undefined')
      throw e;
    
    return defaultValue;
  }
};

export const getOurclubVisitorMatrixZonePrograms = () => getList('ourclub/visitor/matrix_zone/programs', null);


const getData = (method, param, clearMillis) => cache.get(
    null,
    method,
    (context) => Polling.queue(method, param),
    clearMillis
  );

const getList = (method, param, clearMillis) => cache.get(
    null,
    method,
    (context) => Polling.queue(method, param).then((data) => data.list || []),
    clearMillis
  );

const useData = (method, param, onComplete, clearMillis) => cache.use(
    null,
    method,
    (context) => Polling.queue(method, param),
    onComplete,
    clearMillis
  );

const useList = (method, param, onComplete, clearMillis) => cache.use(
    null,
    method,
    (context) => Polling.queue(method, param).then((data) => data.list || []),
    onComplete,
    clearMillis
  );
